<template>
  <div id="page-export-file"  >
    <crud-modal
      v-if="modal && modal.show"
      :show="modal.show"
      :forms="modal.forms"
      :label="modal.label"
      :params="modal.params"
      @action-button="actionButtonModal"
      detail
      @input="(val) => modal.show = val"
    />
    <crud-modal
      v-if="modalSub && modalSub.show"
      :show="modalSub.show"
      :forms="modalSub.forms"
      :label="modalSub.label"
      :params="modalSub.params"
      :detail="modalSub.detail"
      @action-button="actionButtonModalSub"
      @input="(val) => modalSub.show = val"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
const { modal } = JtCrud

@Component({
  name: 'PageExportFile',
  components: { 'crud-modal': modal }
})
class PageExportFile extends Vue {
  modal = null;
  modalSub= null;

  async show ({ button, params, page }) {
    await this.refresh({ label: button.label, params, page })
  }

  async refresh ({ label, params, page }) {
    const forms = await repository.resolve(
      'exportFileSamae.alterar',
      { id: params.exportFileSamae }
    )
    this.modal = {
      show: true,
      label: label,
      forms: forms,
      params: params,
      page: page
    }
  }

  actionButtonModal (button, params, page) {
    switch (button.name) {
      case 'icAdicionarComposicaoAlternative':
        this.icAdicionarComposicaoAlternative(button, params, page)
        break
      case 'icCreatedFileAlternative':
        this.icCreatedFileAlternative(button, params, page)
        break
      case 'icAlterarComposicaoAlternative':
        this.icAlterarComposicaoAlternative(button, params, page)
        break
      case 'icDetalharComposicaoAlternative':
        this.icDetalharComposicaoAlternative(button, params, page)
        break
      default:
        break
    }
  }

  actionButtonModalSub (button, params, page) {
    switch (button.name) {
      case 'btGravar':
        this.btGravar(button, params, page)
        break
      case 'btAlterar':
        this.btAlterar(button, params, page)
        break
      default:
        this.actionInvoice(button, params, page)
        break
    }
  }

  async btGravar (button, params, page) {
    if ((params.convag && params.consumerUnit) ||
    (!params.convag && !params.consumerUnit)) {
      messageBox.warn(this.$gettext('REQUIRED_FIELDS_NOT_FILLED'))
      return
    }
    await repository.resolveLogic(
      button.action,
      { id: this.modal.params.exportFileSamae, ...params }
    )
    this.modalSub.show = false
    await this.refresh({ label: this.modal.label, params: this.modal.params, page: this.modal.page })
  }

  async btAlterar (button, params, page) {
    await repository.resolveLogic(
      button.action,
      { id: this.modal.params.exportFileSamae, ...params }
    )
    this.modalSub.show = false
    await this.refresh({ label: this.modal.label, params: this.modal.params, page: this.modal.page })
  }

  async actionInvoice (button, params) {
    const forms = await repository.resolve(button.action, { id: params.id })
    this.modalSub = {
      show: true,
      detail: true,
      label: button.label,
      forms: forms,
      params: params
    }
  }

  async icAdicionarComposicaoAlternative (button, params, page) {
    const forms = await repository.resolve(
      'exportFileSamaeInvoice.gravar',
      { }
    )
    this.modalSub = {
      show: true,
      detail: false,
      label: button.label,
      forms: forms,
      params: params
    }
  }

  async icCreatedFileAlternative (button, params, page) {
    await repository.resolveLogic(
      'exportFileSamae.createdFile',
      { id: this.modal.params.id, ...params }
    )
    this.modal.show = false
    this.modal.page.$refs.jtDataTable.refresh()
  }

  async icAlterarComposicaoAlternative (button, params, page) {
    const forms = await repository.resolve(
      'exportFileSamaeInvoice.alterar',
      { id: params.id }
    )
    this.modalSub = {
      show: true,
      detail: false,
      label: button.label,
      forms: forms,
      params: params
    }
  }

  async icDetalharComposicaoAlternative (button, params, page) {
    const forms = await repository.resolve(
      'consumerUnit.alterar',
      {
        id: params.consumerUnit
      }
    )
    this.modalSub = {
      show: true,
      detail: true,
      label: button.label,
      forms: forms,
      params: params
    }
  }
}
export default PageExportFile
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
